import { logError } from '@/utils/errorReporter'
import * as cache from '@/navbar/utils/app-switcher-visibility-cache'

export default class FeatureFlagApi {
  constructor(
    private readonly domain: string,
    private readonly organisationId: string | undefined,
    private readonly tenantId: string | undefined,
    private readonly product: string,
  ) {
    if (!domain.startsWith('https://') && !domain.startsWith('http://')) {
      this.domain = `https://${this.domain}`
    }

    if (this.domain.endsWith('/')) {
      this.domain = this.domain.slice(0, -1)
    }
  }

  async checkAppSwitcherVisibility(): Promise<boolean> {
    const orgId = this.organisationId ?? this.tenantId ?? ''

    const cached = cache.read(orgId, this.product, this.domain)
    if (cached !== undefined) return cached

    const path = 'anonymous/app_switcher'

    try {
      const params = new URLSearchParams({ callerProduct: this.product })
      if (this.organisationId) params.set('callerOrganisation', this.organisationId)
      if (this.tenantId) params.set('callerTenantId', this.tenantId)
      const url = `${this.domain}/${path}?${params}`

      const response = await fetch(url)

      if (!response.ok) {
        throw new Error(`Feature Flag request failed: HTTP ${response.status}`)
      }

      const contentType = response.headers.get('Content-Type') ?? ''
      if (!contentType.includes('application/json')) {
        throw new Error('Feature Flag response was not JSON')
      }

      const body: unknown = await response.json()

      if (typeof body === 'object' && body !== null && 'enabled' in body) {
        const result = (body as { enabled: boolean }).enabled === true
        cache.write(orgId, this.product, this.domain, result)
        return result
      } else {
        throw new Error('Unexpected Feature Flag response body')
      }
    } catch (error) {
      logError(error, { source: 'FeatureFlagApi.checkAppSwitcherVisibility' })
      return false
    }
  }
}
